const User = () =>{
    return (
        <>
            사용자
        </>
    )
}

export default User